import { RoleAccessToggle } from './role-access-toggle'
import { PermissionSection } from '../types/roles-page-types'

interface RoleSettingsProps {
  getFieldProps: any
  permissions: PermissionSection[]
}

export const RoleSettings = ({ getFieldProps, permissions }: RoleSettingsProps) => {
  return (
    <div className="row">
      {permissions.map((section: PermissionSection) => (
        <div
          key={section.sectionId}
          className="px-1 col-12 col-md-4 mb-3"
        >
          <h6 className="mb-2">{section.sectionName}</h6>
          {section.permissions.map((permission) => (
            <RoleAccessToggle
              key={permission.key}
              label={permission.name}
              {...getFieldProps(`permissions.${permission.id}`)}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
